import { render } from "./ClientSpaceResume.vue?vue&type=template&id=688b304b&scoped=true"
import script from "./ClientSpaceResume.vue?vue&type=script&lang=js"
export * from "./ClientSpaceResume.vue?vue&type=script&lang=js"

import "@/assets/scss/_clientSpaceResume.scss?vue&type=style&index=0&id=688b304b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688b304b"]])

export default __exports__